var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.url_file_val)?_c('span',[_c('img',{staticStyle:{"vertical-align":"middle","width":"75px","min-width":"70px"},attrs:{"src":_vm.url_file}})]):_c('span',[_c('i',{staticClass:"fas fa-picture-o btn-edit",attrs:{"title":"Sem imagem"}})])}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d443a05c","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/Orders_v2/Aggregates/ImgOnOff.vue
// module id = 6d6O
// module chunks = 0